
export const columns = [
  {
    Header: 'Date',
    accessor: 'awardedDate',
  },
  {
    Header: 'Contract Number',
    accessor: 'contractNumber',
  },
  {
    Header: 'Cage',
    accessor: 'cage',
  },
  {
    Header: 'Company Name',
    accessor: 'supplierName',
  },
  {
    Header: 'Quantity',
    accessor: 'quantity',
  },
  {
    Header: 'Unit Cost',
    accessor: 'unitCost',
  },
  {
    Header: 'Extended Price',
    accessor: 'extendedPrice'
  }
];

export default {
  columns,
};



// WEBPACK FOOTER //
// ./src/components/grids/ProcurementHistoryGrid/gridConfig.jsx